import PriceOfferActions from 'components/tables/data/price-offer/PriceOfferActions';
import { PriceOfferRow, PriceOfferStatusChangingAction } from 'components/tables/data/price-offer/types';
import { noop } from 'lodash';

interface ActionsColumnProps {
  data: PriceOfferRow;
  onChanged?: (actionName?: PriceOfferStatusChangingAction, priceOffer?: PriceOfferRow) => void;
}

/**
 * Column for price offer actions.
 */
export default function ActionsColumn({ data, onChanged = noop }: ActionsColumnProps) {
  return <PriceOfferActions priceOffer={data} onChanged={onChanged} />;
}
